/**
 * Price formatting utilities for checkout module
 * @see mobile: ui-react-native-core/src/hooks/use-price.ts
 */

interface FormatPriceParams {
    amount: number;
    currencyCode?: string;
    locale?: string;
}

/**
 * Format price with currency
 * Clone from mobile formatPrice function
 */
export const formatPrice = ({ amount, currencyCode = 'VND', locale = 'vi-VN' }: FormatPriceParams): string => {
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'code',
    });

    if (currencyCode === 'VND') {
        const formattedAmount = formatter.format(amount);
        return formattedAmount.replace('VND', 'đ').replace(/\s/g, '');
    }

    return formatter.format(amount);
};
